





















































import Vue from 'vue';
/* globals process */

import { getContentArea } from '@/contentful';

import FooterLinkList from '@/components/global-components/global-footer-component/footer-components/footer-link-list.component.vue';
import { MemberCustomerServiceInfoResponseModel } from '@/@types/member';

interface Data {
  clientName: string;
  companyInformation: string;
  companyWebsite: string;
  relatedSitesLinkGroup: {
    heading: string,
    content: string,
  };
  resourcesLinkGroup: {
    heading: string,
    content: string,
  };
  needHelpLinkGroup: {
    heading: string,
    content: string,
  };
}

export default Vue.extend({
  name: 'FooterPrimary',
  beforeMount() {
    getContentArea([
      'footer-information',
      'related-sites-link-list',
      'resources-link-list',
      'need-help-link-list',
    ]).then((data) => {
      const contentAreas = data;
      if (contentAreas) {
        if (contentAreas[0] && contentAreas[0].fields) {
          this.companyInformation = contentAreas[0].fields.companyDescription;
          this.companyWebsite = contentAreas[0].fields.companyWebsite;
        }
        if (contentAreas[1] && contentAreas[1].fields) {
          this.relatedSitesLinkGroup.heading = contentAreas[1].fields.headline;
          this.relatedSitesLinkGroup.content = contentAreas[1].fields.content;
        }
        if (contentAreas[2] && contentAreas[2].fields) {
          this.resourcesLinkGroup.heading = contentAreas[2].fields.headline;
          this.resourcesLinkGroup.content = contentAreas[2].fields.content;
        }
        if (contentAreas[3] && contentAreas[3].fields) {
          this.needHelpLinkGroup.heading = contentAreas[3].fields.headline;
          this.needHelpLinkGroup.content = contentAreas[3].fields.content;
        }
      }
    });
  },
  data(): Data {
    return {
      clientName: process.env.VUE_APP_CLIENT_NAME,
      companyInformation: '',
      companyWebsite: '',
      relatedSitesLinkGroup: {
        heading: '',
        content: '',
      },
      resourcesLinkGroup: {
        heading: '',
        content: '',
      },
      needHelpLinkGroup: {
        heading: '',
        content: '',
      },
    };
  },
  computed: {
    customerServiceInfo(): MemberCustomerServiceInfoResponseModel {
      return this.$store.getters.customerServiceInformation;
    },
    hasCustomerServiceInfo(): boolean {
      return !(
        Object.keys(this.customerServiceInfo).length === 0 &&
        this.customerServiceInfo.constructor === Object
      );
    },
  },
  components: {
    FooterLinkList,
  },
});
